import { useEffect, useState } from "react";
import { fetchUsers } from "./services/HarvestService";
import { getWorkDaysInMonth } from "./utiil/Dates";
import MissingTimeEntries from "./MissingTimeEntries";

const SWEDISH_COMPANIES = [
  1234567, // Variant Sverige AB
  // Eventuelt flere senere
];

function buildUserHoursMap(accounts, period) {
  const userHours = new Map();

  Object.values(accounts).forEach((company) => {
    Object.values(company.projects || {}).forEach((project) => {
      if (
        project.period?.year !== period.year ||
        project.period?.month !== period.month
      ) {
        return;
      }

      Object.values(project.users || {}).forEach((user) => {

        if (user.isSubSuplier) {
          return;
        }
        userHours.set(user.id, (userHours.get(user.id) || 0) + user.sum_hours);
      });
    });
  });

  return userHours;
}

const TrackingStatus = ({ accounts, period, waitingForData, onStatusReady }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (waitingForData) return;

    const load = async () => {
      try {
        const allUsers = (
          await Promise.all(
            Object.values(accounts).map(async (company) => {
              const users = await fetchUsers(company.id);

              return users.map((user) => ({
                ...user,
                companyId: company.id,
                companyName: company.name,
                country: SWEDISH_COMPANIES.includes(company.id) ? "SE" : "NO",
              }));
            }),
          )
        ).flat();

        const userHours = buildUserHoursMap(accounts, period);
        const status = allUsers
          .filter((user) => user.is_active)
          .filter((user) => !user.is_contractor)
          .map((user) => {
            const actualHours = userHours.get(user.id) || 0;
            const expectedHours =
              (user.weekly_capacity / 3600 / 5) *
              getWorkDaysInMonth(period, user.country);
            return {
              ...user,
              actualHours,
              expectedHours,
              missingHours: expectedHours - actualHours,
            };
          });

        setUsers(status);

        if (onStatusReady) {
          const missingByCompany = {};
          status.filter(u => u.missingHours > 0).forEach(u => {
            if (!missingByCompany[u.companyId]) missingByCompany[u.companyId] = [];
            missingByCompany[u.companyId].push(u);
          });
          onStatusReady(missingByCompany);
        }
      } catch (error) {
        console.error(error);
      } finally {
      }
    };

    load();
  }, [accounts, period, waitingForData, onStatusReady]);

  const usersMissingHours = users.filter((user) => user.missingHours > 0);

  const readyForInvoicing = usersMissingHours.length === 0;

  if (waitingForData) {
    return null;
  }
  if (users.length === 0) return <div>Checking time tracking status...</div>;
  return (
    <div>
      {readyForInvoicing ? (
        "✅ All time sheets are done. Invoicing can start."
      ) : (
        <MissingTimeEntries users={usersMissingHours} />
      )}
    </div>
  );
};

export default TrackingStatus;
